// extracted by mini-css-extract-plugin
export default {"video-link":"q_br d-flex align-items-center my-2","video-link__link":"q_bs ml-2"};